import React, { useEffect, useRef, useState } from 'react'
import { InputDiv, Label, Input, SearchOptions, Option } from '../../styles/select-style'
import axios from '../../../config/axios'
import { OrderItemType, PropsType } from './types'

const SelectOrderItemInService :React.FC<PropsType> = ({service, setService}) => {
  const [ items, setItems ] = useState<OrderItemType[]>([])
  const [ inputItem, setInputItem ] = useState<string>('')
  const [ showOptions, setShowOptions ] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const optionsRef = useRef<HTMLUListElement>(null)
  const [ selectedIndex, setSelectedIndex ] = useState(0)
  
  useEffect(() => {
    setSelectedIndex(0)
    axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/service/utils/items/${service.orderId}`)
      .then(response => {
        if(response.data) setItems(response.data)
          console.log(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  }, [inputItem, service.orderId])
  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        optionsRef.current &&
        inputRef.current &&
        !optionsRef.current.contains(target) &&
        !inputRef.current.contains(target)
      ) {
        setShowOptions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputItem(e.target.value)
  }

  const handleSelectItem = (item:OrderItemType) => {
    setService(prev => ({...prev, orderItem: {id: item.id, product: item.product}}))
    setShowOptions(false)
    setInputItem(item.product)
  }
  
  const handleSetOptionByKey = (e:React.KeyboardEvent) => {
    if(e.key === 'ArrowDown' && selectedIndex < items.length - 1) setSelectedIndex(prev => prev + 1)
    if(e.key === 'ArrowUp' && selectedIndex > 0) setSelectedIndex(prev => prev - 1)
    if(e.key === 'Enter') handleSelectItem(items[selectedIndex])
    if(e.key === 'Tab') setShowOptions(false)
  }

  return(
    <InputDiv>
      <Label>Item do pedido</Label>
      <Input 
        ref={inputRef}
        type='text' 
        placeholder='Selecione'
        value={inputItem}
        onFocus={() => setShowOptions(true)}
        onChange={handleChangeInput}
        onKeyDown={(e) => handleSetOptionByKey(e)}
      />
      {showOptions && 
        <SearchOptions ref={optionsRef}>
          {items.map((oI, index) => 
            <Option 
              key={index}
              onClick={() => handleSelectItem(oI)}
              isSelected={index === selectedIndex}
            >
              {oI.product}
            </Option>
          )}
        </SearchOptions>
      }
    </InputDiv>
  )
}

export default SelectOrderItemInService 

